// extracted by mini-css-extract-plugin
export var active = "TabsSection-module--active--4e722";
export var border = "TabsSection-module--border--8857c";
export var emerald = "TabsSection-module--emerald--b396f";
export var fill = "TabsSection-module--fill--83ce7";
export var gold = "TabsSection-module--gold--5ab80";
export var label = "TabsSection-module--label--c6c2b";
export var lilac = "TabsSection-module--lilac--5fb11";
export var pink = "TabsSection-module--pink--f816c";
export var smallTabs = "TabsSection-module--small-tabs--2bf2a";
export var tabContent = "TabsSection-module--tab-content--89af0";
export var tabLabels = "TabsSection-module--tab-labels--9ee5e";
export var tabShape = "TabsSection-module--tab-shape--78fcf";
export var tabsSection = "TabsSection-module--tabs-section--b3f1a";